import { z } from 'zod';

import { zodAddressSchema } from '@vestigas/data';

import { SITE_TYPES } from '../constants';

/**
 * Zod schema for validating the Site GET endpoint path segments
 */
export const zodGetSiteEndpointSchema = z.tuple([
  z.literal('site'),
  z.uuid(), // siteId
]);

/**
 * Zod schema for PermissionsFrom object
 */
const zodPermissionsFromSchema = z.object({
  id: z.number(),
  permissions: z.array(z.string()), // This is very lenient on purpose as permissions will change
  roleId: z.string().nullish(),
  roleName: z.string().nullish(),
  subjectId: z.uuid(),
  subjectName: z.string().nullish(),
  subjectType: z.enum([
    'accounting_reference',
    'company',
    'org_unit',
    'site',
    'user_group',
    'user',
    'vehicle',
  ]),
});

/**
 * Zod schema for Site Identifier object
 */
const zodSiteIdentifierSchema = z.object({
  address: zodAddressSchema,
  blacklisted: z.boolean(),
  identifier: z.string(),
  identifierUuid: z.uuid(),
  identifyingId: z.string().nullish(),
  ignoreAddressInfo: z.boolean(),
  supplierId: z.uuid(),
  supplierName: z.string(),
});

/**
 * Zod schema for the Site response from the API
 */
export const zodSiteResponseSchema = z.object({
  accountingReferenceList: z.array(z.string()),
  accRefSyncKeys: z.array(z.string()).nullish(),
  address: zodAddressSchema,
  companyAccountId: z.uuid(),
  companyId: z.uuid(),
  companySyncKey: z.string().nullish(),
  coords: z.any().optional(),
  end: z.string().nullable(), // TODO: should be z.iso.datetime().nullable(), but we're not getting ISO 8601 dates
  id: z.uuid(),
  identifierList: z.array(zodSiteIdentifierSchema),
  isActive: z.boolean(),
  isSynced: z.boolean().optional(),
  name: z.string(),
  orgUnitPaths: z.array(z.array(z.uuid())),
  orgUnits: z.array(z.uuid()),
  orgUnitsSyncKeys: z.array(z.string()).nullish(),
  permissionsFrom: z.array(zodPermissionsFromSchema),
  start: z.string().nullable(), // TODO: should be z.iso.datetime().nullable(), but we're not getting ISO 8601 dates
  syncKey: z.string().nullish(),
  type: z.enum(SITE_TYPES),
});
